import * as tslib_1 from "tslib";
import { createFeatureSelector, createSelector, Store } from '@ngrx/store';
import * as actions from './actions';
import * as state from './state';
import { Actions, ofType } from '@ngrx/effects';
import { map, take } from 'rxjs/operators';
import { AppStoreService } from '@stop-counter/store';
export class PostsStoreService extends AppStoreService {
    constructor(store, action$) {
        super();
        this.store = store;
        this.action$ = action$;
        this.invoicesState = createFeatureSelector('posts');
        this.selectors = state.invoicesAdapter.getSelectors(this.invoicesState);
        this.isLoading = createSelector(this.invoicesState, state.selectIsLoading);
        this.error = createSelector(this.invoicesState, state.selectError);
    }
    dispatchLoad(type) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            this.dispatchAction(new actions.LoadAction(type));
            return yield this.action$
                .pipe(
            // ERROR tez konczy oczekiwanie: czekanie wylacznie na LOAD_SUCCESS
            // po bledzie HTTP zostawia promise na zawsze - resolver trasy wisi,
            // a SSR renderuje pusty router-outlet ze statusem 200.
            ofType(actions.Actions.LOAD_SUCCESS, actions.Actions.ERROR), map((action) => action.type === actions.Actions.LOAD_SUCCESS ? action.payload : []), take(1))
                .toPromise();
        });
    }
    dispatchLoadSingle(slug) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            this.dispatchAction(new actions.LoadSingleAction(slug));
            return yield this.action$
                .pipe(
            // ERROR tez konczy oczekiwanie: czekanie wylacznie na LOAD_SUCCESS
            // po bledzie HTTP zostawia promise na zawsze - resolver trasy wisi,
            // a SSR renderuje pusty router-outlet ze statusem 200.
            ofType(actions.Actions.LOAD_SUCCESS, actions.Actions.ERROR), map((action) => action.type === actions.Actions.LOAD_SUCCESS ? action.payload : []), take(1))
                .toPromise();
        });
    }
    getAll() {
        return this.store.select(this.selectors.selectAll);
    }
    getItems(type, product, home) {
        return this.store.select(this.selectors.selectAll).pipe(map(e => {
            return e
                .filter(a => a.type === type)
                .filter(a => !product || a.product.includes(product))
                .filter(a => home === undefined || a.promo === home);
        }));
    }
    getItemsByCategory(slug, type, product) {
        return this.store.select(this.selectors.selectAll).pipe(map(e => {
            return e
                .filter(a => a.type === type)
                .filter(a => !product || a.product.includes(product))
                .filter(a => a.categoryNames && !!a.categoryNames.find(c => c.slug === slug));
        }));
    }
    getSingle(slug, product, type) {
        return this.store.select(this.selectors.selectAll).pipe(map(e => {
            return e.find(a => a.slug === slug &&
                (!product ||
                    (a.product.includes(product) && (!type || a.type === type))));
        }));
    }
    getIsLoading() {
        return this.store.select(this.isLoading);
    }
    getError() {
        return this.store.select(this.error);
    }
}
